import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgpMove } from 'ng-primitives/interactions';
import { NgpPopover, NgpPopoverTrigger } from 'ng-primitives/popover';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

import { HelpDirective } from './directive';

import { HelpInlineComponent } from './inline';
import { HelpPanelComponent } from './panel';
import { HelpPanelContentComponent } from './panel/help-panel-content.component';
import { HelpPanelPortalService } from './panel/help-panel-portal.service';
import { HelpPopoverComponent } from './popover';

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule,
    TranslateModule,
    NgpPopover,
    NgpPopoverTrigger,
    NgpMove,
  ],
  declarations: [
    HelpDirective,
    HelpPopoverComponent,
    HelpPanelComponent,
    HelpPanelContentComponent,
    HelpInlineComponent,
  ],
  exports: [
    HelpDirective,
    HelpPopoverComponent,
    HelpPanelComponent,
    HelpInlineComponent,
  ],
})
export class HelpModule {
  // Force portal service initialization for panel rendering at document.body level.
  constructor(private helpPanelPortalService: HelpPanelPortalService) {
    void this.helpPanelPortalService;
  }
}
